<!-- all styles for Shimmer are on the root element, except for any content projection -->
<ng-content></ng-content>
